import { BLOCKS, MARKS, Paragraph, Text, Document } from '@contentful/rich-text-types';
import { textXs } from '@insify/design-system/typography';
import clsx from 'clsx';

import { rawContentToReactComponents } from '~utils/rawContentToReactComponents';
import * as styles from './USPBar.module.css';
import Check from '../assets/check-green.svg';

import type { UspBarContent } from '~models/contentful';

type USPBarProps = {
  content: UspBarContent;
};

export const USPBar: React.FC<USPBarProps> = ({ content }) => {
  const parsedItems = JSON.parse(content.raw) as Document;

  parsedItems.content = parsedItems.content
    .filter((item) => (item as Paragraph).content.some((itemChunk) => !!(itemChunk as Text).value.trim()))
    .splice(0, 3)
    .map((item, index) => ({ ...item, data: { index } }));

  return parsedItems.content.length ? (
    <ul id='insify-usp-bar' className={styles.USPBar}>
      {rawContentToReactComponents(JSON.stringify(parsedItems), {
        renderNode: {
          [BLOCKS.PARAGRAPH]: ({ data }, children) => (
            <li
              className={clsx(textXs, styles.listItem)}
              style={{ '--animation-delay': `${data.index * 5}s` } as React.CSSProperties}
            >
              <Check className={styles.icon} />
              <span>{children}</span>
            </li>
          ),
        },
        renderMark: {
          [MARKS.BOLD]: (text) => <strong className={styles.bold}>{text}</strong>,
        },
      })}
    </ul>
  ) : null;
};
